<template>
  <div
    class="w-100"
  >
    <div
      v-if="isLoaded"
      class="card-header border-bottom mb-3"
    >
      <h5 class="card-title">
        {{ $t(titleChart) }}
      </h5>
    </div>
    <div class="card-body h-100">
      <v-chart
        v-if="isLoaded"
        class="chart"
        :option="option"
        autoresize
      />
    </div>
  </div>
</template>

<script>
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { BarChart } from "echarts/charts";
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  ToolboxComponent,
} from "echarts/components";
import VChart, { THEME_KEY } from "@/plugins/vue-echarts";
use([
  CanvasRenderer,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  ToolboxComponent,
  BarChart,
]);
import { localSave, localRead } from "@/store/lang";
import { convertTimezone } from "@/common/tenancy/convertTimezone.js";
import numeral from "numeral";

export default {
  components: {
    VChart,
  },
  provide: {
    [THEME_KEY]: "default",
  },
  props: {
    titleChart: {
      type: String,
      default() {
        return "";
      },
    },
    chartData: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    let vm = this;
    return {
      lang: localRead("local"),
      hasData: false,
      option: {
        tooltip: {
          // trigger: 'axis',
          // axisPointer: {
          //   // Use axis to trigger tooltip
          //   type: 'shadow' // 'shadow' as default; can also be 'line' or 'shadow'
          // }
          padding: [10, 15],
          textStyle: {
            fontSize: 13,
          },
          borderWidth: 0,
          formatter: (params) => {
            const { data } = params
            const amount = numeral(data.value).format("0,0.00");
            const value = numeral(data.value).format("0,0");
            return vm.titleChart == "_ReportChannel.Sales by Channel Type" ?
              `<b>${vm.$t(data.name)}</b> <br>${vm.$t('_ReportChannel.Total Sales')}: ฿${amount}` :
              `<b>${vm.$t(data.name)}</b> <br>${vm.$t('_ReportChannel.Number of Order')}: ${value}`;
          },
        },
        legend: {},
        grid: {
          top: '3%',
          left: '3%',
          right: '3%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'value',
        },
        yAxis: {
          type: 'category',
          data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
        },
        series: [
          {
            barMaxWidth: 45,
            barWidth: "80%",
            barGap: "10%",
            data: [
              120,
              {
                value: 200,
                itemStyle: {
                  color: '#a90000'
                }
              },
              150,
              80,
              70,
              110,
              130
            ],
            type: 'bar'
          }
        ],
      },
      isLoaded: false,
    };
  },
  async mounted() {
  },
  watch: {
    chartData() {
      this.setData();
    },
  },
  methods: {
    setData() {
      const color = [
        "#FF9E1E",
        "#03A9F4",
        "#6366F1",
        "#66BB6A",
        "#EC4899",
        "#1565C0",
        "#184E77",
        "#00337C",
        "#0081C9",
        "#03C988",
        "#5BC0F8",
        "#FFC93C",
        "#1D1CE5",
        "#4649FF",
        "#C47AFF",
        "#006C9A",
        "#00BEBE",
        "#00F3E4",
        "#9FF9C1",
      ];
      this.isLoaded = true;
      let data = [];
      let yAxisData = [];
      for (const [key, value] of Object.entries(this.chartData)) {
        value.color = color[key];
        data.push({
          ...value,
          itemStyle: {
            color: color[key]
          }
        });
        yAxisData.push(this.$t(value.name))
      }
      if (data && data.length) {
        this.option.series[0].data = data.reverse();
      } else {
        this.option.series[0].data = [];
      }
      if (yAxisData && yAxisData.length) {
        this.option.yAxis.data = yAxisData.reverse();
      } else {
        this.option.yAxis.data = [];
      }
    },
  },
};
</script>

<style scoped>
.chart {
  min-height: 50px;
  height: 310px;
}
</style>



// WEBPACK FOOTER //
// src/components/tenancy/admin/report/finance/chart/salesbychannel/ChartColumnChannel.vue